<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="tenant">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}打分标准
        </div>
        <div class="fr">
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <!-- <b>主信息</b> -->
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  服务性质
                </th>
                <td>
                  <el-select v-model="formData.serverBusinessType" disabled="true">
                    <el-option label="安装" :value="1"/>
                    <el-option label="维修" :value="2"/>
                  </el-select>
                </td>

                <th>
                  <em class="f-red">*</em>
                标准描述
                </th>
                <td colspan="3">
                  <el-input disabled="true" type="textarea" :rows="1" style=""  v-model="formData.nodeDescribe" :maxlength="128" clearable/>
                </td>

              </tr>
              <tr>
                <th>
                 履约节点
                </th>
                <td>
                  <el-select v-model="formData.orderNode" disabled="true">
                    <el-option label="报单" :value="1"/>
                    <el-option label="预约" :value="3"/>
                    <el-option label="上门" :value="5"/>
                    <el-option label="完结" :value="7"/>
                    <el-option label="用户评价" :value="9"/>
                  </el-select>
                </td>

                <th>
                  节点子项
                </th>
                <td>
                  <el-select v-model="formData.nodeProject" disabled="true">
                    <el-option label="关联安装单" :value="1"/>
                    <el-option label="虚拟号外呼记录" :value="2"/>
                    <el-option label="APP打卡记录" :value="3"/>
                    <el-option label="派单时间距离到达签到时间" :value="4"/>
                    <el-option label="完工方式" :value="5"/>
                    <el-option label="工单时长" :value="6"/>
                    <el-option label="评价方式" :value="7"/>
                    <el-option label="评价手机号和用户手机号" :value="8"/>
                    <el-option label="收费信息" :value="9"/>
                  </el-select>
                </td>
              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  分值
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.scores" clearable/>
                </td>
              </tr>
              <tr>
                <th>创建人</th>
                <td>{{ formData.createBy }}</td>
                <th>创建时间</th>
                <td>{{ formData.createTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>

      </div>
    </el-form>
  </div>
</template>
<script>
import {dictType, loadDictData} from "@/config/dictType"
import Tinymce from '@/components/Tinymce';
import api from "@/api/projectApi";
import {fetchTree} from "@/api/admin/type_tree";
import {mapGetters} from "vuex";
import {editPageMixins} from "@/mixins/tabChang";

export default {
  mixins: [editPageMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {

    Tinymce,
  },
  data() {
    return {
      getDataUrl: '/basic/basScoreStandards/get',
      addDataUrl: '/basic/basScoreStandards/save',
      updateDataUrl: '/basic/basScoreStandards/update',

      activeName: 'first',
      dialog: {
        one: false,
      },
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
      // 基本信息
      tenant: {
        status: 0,
        tenantAttachmentDTOs: []
      },

      formData: {
        id: null,  // 主键id,自动新增
        createBy: '',  // 创建人
        createTime: '',  // 创建时间
        serverBusinessType: null,  // 服务类型性质：1安装;2维修
        orderNode: null,  // 履约节点：1报单;3预约;5上门;7完结;9用户评价
        nodeProject: null,  // 节点子项:1关联安装单;2虚拟号外呼记录;3APP打卡记录;4派单时间距离到达签到时间;5完工方式;6工单时长;7评价方式;8评价手机号和用户手机号;9收费信息
        nodeDescribe: null,  // 标准描述(文字说明)
        scores: null,  // 分值

      },
    }
  },

  computed: {
    readonlyField() {
      return this.formData.itemId != null
    },
    ...mapGetters(["permissions"]),
  },

  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
  },
  watch: {

  },
  mounted() {
    this.getData()
  },
  methods: {
    // 回显
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: this.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.formData = response.data.data
          this.loadProductOption1()
        })
      }
    },

    saveData() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()

            this.$http({
              url: this.isEdit ? this.updateDataUrl : this.addDataUrl,
              method: `post`,
              data: this.formData,
              isLoading: true,
            }).then(res => {
              this.$message.success("保存成功！")
              this.goBackIndex()
              this.$mask.close()

            }).catch(e => {
              console.error(e)
              this.$message.error("保存失败！")
              this.$mask.close()

            })
          });
        }
      })
    },

  },
};

</script>
<style lang="scss" scoped>
// 输入框的宽度
#containt .table-detail tbody tr td .el-input {
  width: 100% !important;
  width: 165px !important;
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

.current-date-picker {
  width: 100%;
  border-radius: 2px;
  border-color: #e8e8e8;
  padding: 0 24px 0 8px;
  height: 28px !important;
  line-height: 28px;
}
.current-date-picker[data-v-b58b35ce] {
    width: 85%!important;
    border-radius: 2px;
    border-color: #e8e8e8;
    padding: 0 0px 0 8px!important;
    height: 28px !important;
    line-height: 28px;
}
</style>
